import { definitions } from './schema';
import trackEvent from '../../elements/trackEvent';

export function findModelContext(doc, nav) {
  if (typeof doc?.modelContext?.registerTool === 'function') return doc.modelContext;
  if (typeof nav?.modelContext?.registerTool === 'function') return nav.modelContext;
  return null;
}
const sessions = new WeakMap();
/** Top-level browser tools only. No polyfill, network payload, UI writes or storage. */
export function registerSiteTools({ doc = document, nav = navigator, win = window, record = trackEvent, load = () => import('./calculate') } = {}) {
  if (win.top !== win.self) return () => {};
  const context = findModelContext(doc, nav);
  if (!context) return () => {};
  const existing = sessions.get(context);
  if (existing) {
    existing.references += 1;
    let released = false;
    return () => { if (!released) { released = true; existing.release(); } };
  }
  const controller = new AbortController();
  const names = [];
  const session = { references: 1, release() {
    session.references -= 1;
    if (session.references > 0) return;
    controller.abort();
    if (typeof context.unregisterTool === 'function') names.forEach(name => { try { context.unregisterTool(name); } catch { /* Older implementation may already have removed it. */ } });
    sessions.delete(context);
  } };
  sessions.set(context, session);
  const measure = (name, params) => { try { record(name, params); } catch { /* Measurement cannot interrupt a tool. */ } };
  definitions.forEach(({ path, ...definition }) => {
    const execute = async (args, options = {}) => {
      if (controller.signal.aborted || options.signal?.aborted) return { ok: false, error: { code: 'unavailable', message: 'This page tool is no longer available.' } };
      try {
        const { calculateTool } = await load();
        if (controller.signal.aborted || options.signal?.aborted) return { ok: false, error: { code: 'unavailable', message: 'Tool call cancelled.' } };
        const result = calculateTool(definition.name, args);
        measure(result.ok ? 'agent_tool_complete' : 'agent_tool_error', { page_path: path, interaction: 'agent', ...(result.ok ? {} : { error_category: result.error.code }) });
        return result;
      } catch {
        measure('agent_tool_error', { page_path: path, interaction: 'agent', error_category: 'calculation' });
        return { ok: false, error: { code: 'calculation', message: 'The calculation could not be completed. Try the website calculator.' } };
      }
    };
    try {
      const registration = context.registerTool({ ...definition, annotations: { readOnlyHint: true }, execute }, { signal: controller.signal });
      names.push(definition.name);
      // The current draft registration promise can remain pending until cancellation.
      Promise.resolve(registration).catch(() => {
        if (!controller.signal.aborted) measure('agent_tool_error', { page_path: path, interaction: 'agent', error_category: 'unavailable' });
      });
    } catch {
      measure('agent_tool_error', { page_path: path, interaction: 'agent', error_category: 'unavailable' });
    }
  });
  let released = false;
  return () => { if (!released) { released = true; session.release(); } };
}
